import { render, staticRenderFns } from "./ServicesPresentation.vue?vue&type=template&id=0559862e&scoped=true&"
import script from "./ServicesPresentation.vue?vue&type=script&lang=js&"
export * from "./ServicesPresentation.vue?vue&type=script&lang=js&"
import style0 from "./ServicesPresentation.vue?vue&type=style&index=0&id=0559862e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0559862e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow})
